<template>
    <div>
        loading
    </div>
</template>

<script>
export default {
    mounted() {
        this._startHighlights();
    },
    methods: {
        _startHighlights: function() {
            this.$router.push({ name: 'highlight.1' });
        }
    }
}
</script>
